export enum BidTradeType {
  /** Agency */
  Agency = 'A',
  /** VWAP Guarantee */
  VWAPGuarantee = 'G',
  /** Guaranteed Close */
  GuaranteedClose = 'J',
  /** Risk Trade */
  RiskTrade = 'R',
}
